<template>
	<div class="notice_popup stipPup" :class="isMobile ? 'mobile' : ''">
		<div class="close">
            <img src="/images/close.png" alt="닫기" @click="$emit('close', false)"/>
		</div>
		<div class="tit"></div>
		<div class="main-contents">
			<div class="mem_container" :class="isMobile ? 'mobile' : ''">
				<div class="mem_agree_contents stip" :class="isMobile ? 'mobile' : ''">
					<div class="mem_contents_body stip" :class="isMobile ? 'mobile':''">
						<div class="body-top" :class="isMobile ? 'mobile' : ''" style="text-align:center;"><p>{{stipReChk.stipNm}}</p></div>
						<div v-html="stipReChk.stipCont"></div>
						<div class="agree-check stip" :class="isMobile ? 'mobile':''">
							<input type="checkbox" :id="'chk'+stipReChk.stipDivCd" v-model="stipReChk.agreeYn"> <label :for="'chk'+stipReChk.stipDivCd">{{stipReChk.stipNm}}을(를) 확인하였고, 이에 동의합니다.</label>
						</div>
					</div>
				</div>
				<div class="select-btn pup" :class="isMobile ? 'mobile' : ''">
					<div class="btn" @click="$emit('close', false)">동의하지 않음</div>
					<div class="btn" @click="btnSubmit()">동의함</div>
				</div>
			</div>
		</div>
	 </div>
	 <!-- <div>
		<div class="main-contents">
			<div class="mem_container">
				<div class="mem_agree_contents stip" :style="isMobile ?  'height: 1650px;':'height: 1340px;'">
					<div class="mem_contents_body stip">
						<div class="body-top" style="text-align:center;"><p>{{stipReChk.stipNm}}</p></div>
						<div v-html="stipReChk.stipCont"></div>
						<div class="agree-check stip">
							<input type="checkbox" :id="'chk'+stipReChk.stipDivCd" v-model="stipReChk.agreeYn"> <label :for="'chk'+stipReChk.stipDivCd">{{stipReChk.stipNm}}을(를) 확인하였고, 이에 동의합니다.</label>
						</div>
					</div>
				</div>
				<div class="select-btn pup" style="margin-bottom: 10px;">
					<div class="btn" @click="pupClose()">동의하지 않음</div>
					<div class="btn" @click="btnSubmit()">동의함</div>
				</div>
			</div>
		</div>
	 </div> -->
</template>

<script>

export default {
	data(){
		return {			
			stipReChk: {},
			isMobile:false,
		}
	},

	mounted() {
		this.isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
		this.getStipRck();
	},

	methods : {
		getStipRck() {
			this.$.httpPost('/api/mem/selectStipCont', {stipDivCd: '03'})
				.then(res => {
					if(res.data.resultCode == '000') {
						var rplStr = 'agreebox full pup';
						if(this.isMobile) rplStr += ' mobile';

						// var stipTemp = res.data.data.stipList[0];
						// stipTemp.stipCont = stipTemp.stipCont.replace('agreebox full', rplStr);

						// this.stipReChk = stipTemp;

						this.stipReChk = res.data.data.stipList[0];
						this.stipReChk.stipCont = this.stipReChk.stipCont.replace('agreebox full', rplStr);

						if(this.isMobile) this.stipReChk.stipCont = this.stipReChk.stipCont.replaceAll('tit', 'tit mobile');
					}
				});
		},
		btnSubmit() {
			if(this.stipReChk.mandYn == 'Y' && !this.stipReChk.agreeYn) {
				alert('\'' + this.stipReChk.stipNm + '\'은(는) 필수약관 입니다.');
				return;
			}

			this.$emit('close', {stipReChk : this.stipReChk});

			// window.opener.setStipReChk({stipReChk : this.stipReChk});
		},
		pupClose() {
			window.close();
		},
	}
}
</script>